var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.905882,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.742188 1.367188 C 23.242188 1.367188 35.742188 1.367188 48.242188 1.367188 C 48.242188 5.011719 48.242188 8.660156 48.242188 12.304688 C 47.722656 12.304688 47.199219 12.304688 46.679688 12.304688 C 46.679688 9.179688 46.679688 6.054688 46.679688 2.929688 C 35.222656 2.929688 23.761719 2.929688 12.304688 2.929688 C 12.238281 5.925781 12.304688 8.921875 12.5 11.914062 C 13.152344 12.375 13.738281 12.894531 14.257812 13.476562 C 16.617188 12.769531 17.855469 13.679688 17.96875 16.210938 C 20.261719 17.175781 20.714844 18.738281 19.335938 20.898438 C 19.957031 21.550781 20.214844 22.332031 20.117188 23.242188 C 27.152344 23.371094 34.183594 23.242188 41.210938 22.851562 C 41.472656 21.808594 42.121094 21.160156 43.164062 20.898438 C 43.683594 16.730469 43.683594 12.566406 43.164062 8.398438 C 42.121094 8.136719 41.472656 7.488281 41.210938 6.445312 C 33.398438 5.925781 25.585938 5.925781 17.773438 6.445312 C 17.511719 7.488281 16.863281 8.136719 15.820312 8.398438 C 15.5 9.550781 15.304688 10.722656 15.234375 11.914062 C 14.84375 12.433594 14.453125 12.433594 14.0625 11.914062 C 13.738281 10.207031 13.804688 8.515625 14.257812 6.835938 C 15.300781 6.574219 15.949219 5.925781 16.210938 4.882812 C 25.066406 4.363281 33.917969 4.363281 42.773438 4.882812 C 43.035156 5.925781 43.683594 6.574219 44.726562 6.835938 C 45.246094 12.042969 45.246094 17.253906 44.726562 22.460938 C 43.683594 22.722656 43.035156 23.371094 42.773438 24.414062 C 34.546875 24.621094 26.34375 24.949219 18.164062 25.390625 C 17.753906 25.933594 17.6875 26.519531 17.96875 27.148438 C 19.746094 29.53125 20.984375 32.132812 21.679688 34.960938 C 20.242188 35.015625 18.875 34.753906 17.578125 34.179688 C 17.03125 35.296875 16.640625 36.46875 16.40625 37.695312 C 15.753906 38.214844 15.105469 38.214844 14.453125 37.695312 C 13.570312 36.054688 12.59375 34.492188 11.523438 33.007812 C 10.453125 34.492188 9.476562 36.054688 8.59375 37.695312 C 8.0625 38.039062 7.476562 38.167969 6.835938 38.085938 C 6.835938 38.867188 6.835938 39.648438 6.835938 40.429688 C 11.523438 40.429688 16.210938 40.429688 20.898438 40.429688 C 20.898438 40.949219 20.898438 41.472656 20.898438 41.992188 C 23.503906 41.992188 26.105469 41.992188 28.710938 41.992188 C 28.710938 41.472656 28.710938 40.949219 28.710938 40.429688 C 33.398438 40.429688 38.085938 40.429688 42.773438 40.429688 C 42.773438 37.824219 42.773438 35.222656 42.773438 32.617188 C 43.292969 32.617188 43.816406 32.617188 44.335938 32.617188 C 44.335938 35.222656 44.335938 37.824219 44.335938 40.429688 C 45.636719 40.429688 46.941406 40.429688 48.242188 40.429688 C 49 43.921875 47.828125 46.460938 44.726562 48.046875 C 36.265625 48.242188 27.800781 48.308594 19.335938 48.242188 C 19.335938 47.722656 19.335938 47.199219 19.335938 46.679688 C 27.691406 46.859375 36.023438 46.664062 44.335938 46.09375 C 45.671875 45.210938 46.453125 43.976562 46.679688 42.382812 C 41.21875 41.992188 35.75 41.863281 30.273438 41.992188 C 30.273438 42.511719 30.273438 43.035156 30.273438 43.554688 C 26.628906 43.554688 22.980469 43.554688 19.335938 43.554688 C 19.335938 43.035156 19.335938 42.511719 19.335938 41.992188 C 13.859375 41.863281 8.390625 41.992188 2.929688 42.382812 C 3.15625 43.976562 3.9375 45.210938 5.273438 46.09375 C 9.414062 46.640625 13.582031 46.835938 17.773438 46.679688 C 17.773438 47.199219 17.773438 47.722656 17.773438 48.242188 C 13.054688 48.414062 8.367188 48.21875 3.710938 47.65625 C 1.539062 45.75 0.757812 43.34375 1.367188 40.429688 C 2.667969 40.429688 3.972656 40.429688 5.273438 40.429688 C 5.273438 38.476562 5.273438 36.523438 5.273438 34.570312 C 3.980469 34.785156 2.679688 34.914062 1.367188 34.960938 C 1.769531 32.851562 2.613281 30.898438 3.90625 29.101562 C 4.4375 28.757812 5.023438 28.628906 5.664062 28.710938 C 5.808594 30.066406 5.417969 31.238281 4.492188 32.226562 C 5.324219 32.183594 6.238281 32.3125 7.226562 32.617188 C 7.414062 33.175781 7.671875 33.695312 8.007812 34.179688 C 9.03125 32.960938 9.8125 31.59375 10.351562 30.078125 C 9.574219 28.257812 8.269531 27.734375 6.445312 28.515625 C 5.511719 27.777344 5.058594 26.800781 5.078125 25.585938 C 2.785156 24.621094 2.332031 23.058594 3.710938 20.898438 C 2.683594 19.519531 2.683594 18.152344 3.710938 16.796875 C 6.21875 16.457031 6.609375 17.171875 4.882812 18.945312 C 5.925781 20.246094 5.925781 21.550781 4.882812 22.851562 C 6.558594 23.59375 7.46875 24.894531 7.617188 26.757812 C 9.246094 26.066406 10.550781 26.457031 11.523438 27.929688 C 12.496094 26.457031 13.800781 26.066406 15.429688 26.757812 C 15.578125 24.894531 16.488281 23.59375 18.164062 22.851562 C 17.121094 21.550781 17.121094 20.246094 18.164062 18.945312 C 16.488281 18.203125 15.578125 16.902344 15.429688 15.039062 C 13.800781 15.730469 12.496094 15.339844 11.523438 13.867188 C 10.550781 15.339844 9.246094 15.730469 7.617188 15.039062 C 7.160156 16.125 6.441406 16.386719 5.46875 15.820312 C 5.414062 13.46875 6.523438 12.6875 8.789062 13.476562 C 9.308594 12.894531 9.894531 12.375 10.546875 11.914062 C 10.742188 8.402344 10.808594 4.886719 10.742188 1.367188 Z M 13.867188 28.320312 C 14.765625 28.539062 15.675781 28.734375 16.601562 28.90625 C 17.425781 30.09375 18.011719 31.332031 18.359375 32.617188 C 16.671875 31.898438 15.566406 32.417969 15.039062 34.179688 C 14.015625 32.960938 13.234375 31.59375 12.695312 30.078125 C 13.011719 29.4375 13.402344 28.851562 13.867188 28.320312 Z M 13.867188 28.320312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 22.460938 7.617188 C 27.148438 7.617188 31.835938 7.617188 36.523438 7.617188 C 36.523438 8.136719 36.523438 8.660156 36.523438 9.179688 C 32.355469 9.179688 28.191406 9.179688 24.023438 9.179688 C 24.023438 9.699219 24.023438 10.222656 24.023438 10.742188 C 28.191406 10.742188 32.355469 10.742188 36.523438 10.742188 C 36.523438 11.261719 36.523438 11.785156 36.523438 12.304688 C 31.835938 12.304688 27.148438 12.304688 22.460938 12.304688 C 22.460938 10.742188 22.460938 9.179688 22.460938 7.617188 Z M 22.460938 7.617188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.023438 13.867188 C 27.667969 13.867188 31.316406 13.867188 34.960938 13.867188 C 34.960938 14.386719 34.960938 14.910156 34.960938 15.429688 C 31.316406 15.429688 27.667969 15.429688 24.023438 15.429688 C 24.023438 14.910156 24.023438 14.386719 24.023438 13.867188 Z M 24.023438 13.867188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 46.679688 13.867188 C 47.199219 13.867188 47.722656 13.867188 48.242188 13.867188 C 48.242188 18.554688 48.242188 23.242188 48.242188 27.929688 C 38.738281 27.929688 29.230469 27.929688 19.726562 27.929688 C 19.726562 27.410156 19.726562 26.886719 19.726562 26.367188 C 28.710938 26.367188 37.695312 26.367188 46.679688 26.367188 C 46.679688 22.199219 46.679688 18.035156 46.679688 13.867188 Z M 46.679688 13.867188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.760784,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.570312 16.210938 C 10.878906 16.148438 12.179688 16.210938 13.476562 16.40625 C 13.820312 16.9375 13.949219 17.523438 13.867188 18.164062 C 9.675781 17.339844 8.179688 18.902344 9.375 22.851562 C 13.394531 24.375 15.019531 22.941406 14.257812 18.554688 C 14.898438 18.472656 15.484375 18.601562 16.015625 18.945312 C 16.96875 22.445312 15.730469 24.726562 12.304688 25.78125 C 8.835938 25.996094 6.882812 24.371094 6.445312 20.898438 C 6.730469 18.796875 7.773438 17.234375 9.570312 16.210938 Z M 9.570312 16.210938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.679688 16.992188 C 28.191406 16.992188 34.699219 16.992188 41.210938 16.992188 C 41.210938 17.511719 41.210938 18.035156 41.210938 18.554688 C 34.699219 18.554688 28.191406 18.554688 21.679688 18.554688 C 21.679688 18.035156 21.679688 17.511719 21.679688 16.992188 Z M 21.679688 16.992188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.679688 20.117188 C 27.148438 20.117188 32.617188 20.117188 38.085938 20.117188 C 38.085938 20.636719 38.085938 21.160156 38.085938 21.679688 C 32.617188 21.679688 27.148438 21.679688 21.679688 21.679688 C 21.679688 21.160156 21.679688 20.636719 21.679688 20.117188 Z M 21.679688 20.117188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.941176,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.242188 29.492188 C 30.273438 29.492188 37.304688 29.492188 44.335938 29.492188 C 44.335938 30.011719 44.335938 30.535156 44.335938 31.054688 C 41.992188 31.054688 39.648438 31.054688 37.304688 31.054688 C 37.304688 31.574219 37.304688 32.097656 37.304688 32.617188 C 38.605469 32.617188 39.910156 32.617188 41.210938 32.617188 C 41.210938 33.136719 41.210938 33.660156 41.210938 34.179688 C 39.910156 34.179688 38.605469 34.179688 37.304688 34.179688 C 37.304688 34.699219 37.304688 35.222656 37.304688 35.742188 C 38.347656 35.742188 39.386719 35.742188 40.429688 35.742188 C 40.429688 36.261719 40.429688 36.785156 40.429688 37.304688 C 39.386719 37.304688 38.347656 37.304688 37.304688 37.304688 C 37.304688 37.824219 37.304688 38.347656 37.304688 38.867188 C 32.617188 38.867188 27.929688 38.867188 23.242188 38.867188 C 23.242188 35.742188 23.242188 32.617188 23.242188 29.492188 Z M 27.148438 31.445312 C 29.160156 30.996094 31.242188 30.929688 33.398438 31.25 C 32.410156 32.066406 31.367188 32.785156 30.273438 33.398438 C 29.234375 32.75 28.191406 32.101562 27.148438 31.445312 Z M 24.804688 32.226562 C 26.5 33.59375 28.320312 34.765625 30.273438 35.742188 C 32.183594 34.816406 33.941406 33.644531 35.546875 32.226562 C 35.742188 33.914062 35.808594 35.605469 35.742188 37.304688 C 32.097656 37.304688 28.449219 37.304688 24.804688 37.304688 C 24.804688 35.613281 24.804688 33.917969 24.804688 32.226562 Z M 24.804688 32.226562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.764706,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 6.835938 43.554688 C 7.355469 43.554688 7.878906 43.554688 8.398438 43.554688 C 8.398438 44.074219 8.398438 44.597656 8.398438 45.117188 C 7.878906 45.117188 7.355469 45.117188 6.835938 45.117188 C 6.835938 44.597656 6.835938 44.074219 6.835938 43.554688 Z M 6.835938 43.554688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.764706,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.960938 43.554688 C 10.480469 43.554688 11.003906 43.554688 11.523438 43.554688 C 11.523438 44.074219 11.523438 44.597656 11.523438 45.117188 C 11.003906 45.117188 10.480469 45.117188 9.960938 45.117188 C 9.960938 44.597656 9.960938 44.074219 9.960938 43.554688 Z M 9.960938 43.554688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.764706,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 38.085938 43.554688 C 38.605469 43.554688 39.128906 43.554688 39.648438 43.554688 C 39.648438 44.074219 39.648438 44.597656 39.648438 45.117188 C 39.128906 45.117188 38.605469 45.117188 38.085938 45.117188 C 38.085938 44.597656 38.085938 44.074219 38.085938 43.554688 Z M 38.085938 43.554688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.764706,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 41.210938 43.554688 C 41.730469 43.554688 42.253906 43.554688 42.773438 43.554688 C 42.773438 44.074219 42.773438 44.597656 42.773438 45.117188 C 42.253906 45.117188 41.730469 45.117188 41.210938 45.117188 C 41.210938 44.597656 41.210938 44.074219 41.210938 43.554688 Z M 41.210938 43.554688 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatents);
export default __webpack_public_path__ + "static/media/patents.ff41d587256b5da6f040b9d7699ea60c.svg";
export { ForwardRef as ReactComponent };